import { FC, SVGProps } from "react"

import { Box, Button, Typography } from "@mui/material"
import CleverButton from "components/common/button/cleverButton"
import { useTranslation } from "react-i18next"

interface IProps {
  icon: FC<SVGProps<SVGSVGElement>>
  onSignInWithClever: () => void
  onReset: () => void
}

const CleverRestrictedTakeover = ({ icon: Icon, onSignInWithClever, onReset }: IProps) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ textAlign: "center", py: 6, px: 2 }}>
      <Icon />
      <Typography variant="h2" sx={{ mt: 2, fontWeight: 600 }}>
        {t("noAuthFlow.cleverRestrictedDomainTitle")}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 1, mb: 4, maxWidth: 320, mx: "auto" }}
      >
        {t("noAuthFlow.cleverRestrictedDomainDescription")}
      </Typography>
      <CleverButton
        text={t("noAuthFlow.continueWithClever")}
        onClick={onSignInWithClever}
      />
      <Button fullWidth variant="text" onClick={onReset} sx={{ mt: 1 }}>
        {t("noAuthFlow.cleverRestrictedEnterDifferentEmail")}
      </Button>
    </Box>
  )
}

export default CleverRestrictedTakeover
